//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-bottom-bar',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    close () {
      this.$emit('close');
    },
  },
};
